module.exports = __webpack_public_path__ + "static/img/manual-37.4562d5f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/manual-37.png
// module id = L+Rg
// module chunks = 4